import { coresNomes } from '@constants/Color'
import { ICONES_EVENTS } from '@modules/consolidator/constants/Text'

/**
 * Estilo dos marcadores de movimentações/eventos no gráfico de desempenho do
 * ativo (modal "Ver detalhes").
 *
 * A cor de aplicação/resgate vem do MESMO mapa que as tabelas usam
 * (`ICONES_EVENTS`), pra o marcador e a linha da tabela nunca divergirem.
 * CONTRATO: toda cor daqui tem que ser HEX — o plugin chartjs-goal-markers
 * desenha via `ctx.fillText` no canvas e não resolve nome de cor do Vuetify;
 * um nome quebraria em silêncio. O teste do contrato trava isso.
 *
 * Exceção consciente ao ds/no-emoji: os symbols (↗ ↙ $ %) são glifos
 * renderizados via ctx.fillText DENTRO do canvas 2D do Chart.js — BaseIcon
 * (componente Vue) não é desenhável em canvas; a alternativa do plugin
 * (icon por URL http) exigiria servir assets remotos por marcador.
 */
export const MARKER_STYLES = {
  aplicacao: {
    name: 'Aplicação',
    color: ICONES_EVENTS['Aplicação'].iconColor,
    symbol: '↗',
    targetTab: 'movimentacoes',
  },
  resgate: {
    name: 'Resgate',
    color: ICONES_EVENTS.Resgate.iconColor,
    symbol: '↙',
    targetTab: 'movimentacoes',
  },
  evento: {
    name: 'Evento',
    color: coresNomes.dourado,
    symbol: '$',
    targetTab: 'eventos',
  },
  split: {
    name: 'Split',
    color: coresNomes.dourado,
    symbol: '%',
    targetTab: 'eventos',
  },
}

/**
 * Acima deste número de datas com marcador, o snap deixa de ser diário e
 * agrupa por mês (primeiro label de cada mês) para o gráfico não virar um
 * colar de bolhas.
 */
export const MAX_MARKER_LABELS = 40

/** Períodos do gráfico de desempenho. months null = desde o início. */
export const ASSET_CHART_PERIODS = [
  { key: '6M', label: '6M', months: 6 },
  { key: '12M', label: '12M', months: 12 },
  { key: 'INICIO', label: 'Início', months: null },
]

export const ASSET_CHART_DEFAULT_PERIOD = '12M'

export const ASSET_CHART_WIDEST_PERIOD = ASSET_CHART_PERIODS.find(
  (period) => period.months === null
).key

/** Modos de visualização do gráfico de desempenho. */
export const ASSET_CHART_MODES = {
  RENTABILIDADE: 'rentabilidade',
  PATRIMONIO: 'patrimonio',
}

/** Altura do canvas do grafico de desempenho, em px. */
export const ASSET_CHART_HEIGHT = 340

/**
 * Folga acima do maior valor da serie, pra o marcador do pico caber ACIMA da
 * curva. Sem ela o plugin empurra o marcador pra baixo e ele cobre a linha.
 */
export const ASSET_CHART_TOP_HEADROOM = 1.18

export const PALETA_BENCHMARK = [
  coresNomes.azulProfundo,
  coresNomes.laranjaDinamico,
  coresNomes.roxo,
  coresNomes.azulPetroleo,
  coresNomes.dourado,
  coresNomes.vermelhoControle,
  coresNomes.azulRoyal,
  coresNomes.cinzaEscuro,
]

/** Benchmark exibido quando a classe do ativo nao declara um proprio. */
export const BENCHMARK_PADRAO = 'CDI'
